<template>
  <div
    class="m_pagedPublicationTemplate"
    :class="{ 'is--stacked': mode }"
    :style="setContainerContainer(publication)"
  >
    <div
      class="m_pageContainer"
      :style="setPageContainerProperties(publication)"
      v-for="page in all_pages"
      :key="page.id"
    >
      <div class="m_page" :style="setPageProperties(publication)">
        <div
          class="m_page--header"
          v-if="!!headers.header_left || !!headers.header_right"
        >
          <div>{{ headers.header_left }}</div>
          <div>{{ headers.header_right }}</div>
        </div>

        <MediaPublication
          v-for="media in getMediasOnPageID(page.id)"
          :key="media.metaFileName"
          :media="media"
          :page="page"
          :zoom="zoom"
        />
      </div>
    </div>
  </div>
</template>
<script>
import MediaPublication from "./subcomponents/MediaPublication.vue";

export default {
  props: {
    publication: Object,
    mode: String,
    zoom: {
      type: Number,
      default: 1,
    },
    show_page: Number,
  },
  components: {
    MediaPublication,
  },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  beforeDestroy() {},

  watch: {},
  computed: {
    page_width() {
      if (
        this.model_for_this_publication &&
        this.model_for_this_publication.hasOwnProperty("width")
      )
        return this.model_for_this_publication.width;

      return this.publication.hasOwnProperty("width")
        ? this.publication.width
        : 210;
    },
    page_height() {
      if (
        this.model_for_this_publication &&
        this.model_for_this_publication.hasOwnProperty("height")
      )
        return this.model_for_this_publication.height;

      return this.publication.hasOwnProperty("height")
        ? this.publication.height
        : 297;
    },
    model_for_this_publication() {
      if (!this.publication.follows_model) return false;
      return Object.values(this.$root.publications).find(
        (p) =>
          this.publication.template === p.template &&
          p.is_model === true &&
          p.slugFolderName === this.publication.follows_model
      );
    },
    publication_model_medias() {
      return Object.values(this.model_for_this_publication.medias);
    },
    medias() {
      return Object.values(this.publication.medias);
    },
    // medias_with_replies() {
    //   // if publi is a reply to another publi
    //   if (this.publication.slugFolderName !== this.source_publication) {
    //     const model_medias = this.source_publication.medias;
    //     return Object.entries(model_medias).map(([_metaFileName, m]) => {
    //       if (m.type === "placeholder") {
    //         // find medias in publi that refer to this placeholder
    //         const reply_placeholder = Object.values(
    //           this.publication.medias
    //         ).filter(
    //           (publi_media) =>
    //             publi_media.type === "placeholder" &&
    //             publi_media.placeholder_meta_reference === _metaFileName
    //         );
    //         if (reply_placeholder.length > 0) {
    //           placeholder_medias_slugs;
    //         }
    //       }
    //     });
    //   }
    //   return this.source_publication.medias;
    // },
    paged_medias() {
      const publication = this.model_for_this_publication
        ? this.model_for_this_publication
        : this.publication;

      // récupérer tous les médias du modèle
      const medias = this.model_for_this_publication
        ? this.publication_model_medias
        : this.medias;

      // return this.$_.groupBy(this.medias, "page_id");

      return medias.reduce((acc, media) => {
        const _media = JSON.parse(JSON.stringify(media));
        if (this.model_for_this_publication && media.type === "placeholder") {
          const placeholder_reply_media = this.medias.find(
            (m) => m.placeholder_meta_reference === media.metaFileName
          );
          if (placeholder_reply_media) {
            _media._reply = placeholder_reply_media;

            if (
              placeholder_reply_media.hasOwnProperty(
                "placeholder_medias_slugs"
              ) &&
              Array.isArray(placeholder_reply_media.placeholder_medias_slugs)
            ) {
              const reply_medias = placeholder_reply_media.placeholder_medias_slugs.reduce(
                (acc, { slugMediaName }) => {
                  const corresponding_media = this.medias.find(
                    (m) => m.metaFileName === slugMediaName
                  );
                  if (corresponding_media) acc.push(corresponding_media);
                  return acc;
                },
                []
              );
              if (reply_medias.length > 0) {
                _media._reply._medias = reply_medias;
              }
            }
          }
        }

        const page_id = _media.page_id;
        if (!acc.hasOwnProperty(page_id)) acc[page_id] = [];

        acc[page_id].push(_media);

        return acc;
        // si le média du modèle est un placeholder
        // chercher les médias de la réponse qui contiennent une référence au modèle
      }, {});
    },

    all_pages() {
      const publi = this.model_for_this_publication
        ? this.model_for_this_publication
        : this.publication;

      if (!publi || !publi.hasOwnProperty("pages")) return false;

      if (!!this.show_page)
        return publi.pages.slice(this.show_page - 1, this.show_page);

      return publi.pages;
    },

    headers() {
      const ref = this.model_for_this_publication
        ? this.model_for_this_publication
        : this.publication;

      return {
        header_left: ref.header_left,
        header_right: ref.header_right,
      };
    },
  },
  methods: {
    getMediasOnPageID(id) {
      if (this.$root.state.dev_mode === "debug") {
        console.log(`METHODS • PagedPublicationTemplate: getMediasOnPageID`);
      }

      return this.paged_medias.hasOwnProperty(id)
        ? this.paged_medias[id]
        : false;
    },

    setContainerContainer() {
      if (this.$root.state.mode === "print_publication") return;

      if (
        this.model_for_this_publication &&
        this.model_for_this_publication.hasOwnProperty("page_width")
      ) {
        if (this.mode === "stacked") {
          return `
            width: ${this.model_for_this_publication.page_width * this.zoom}mm;
            height: ${this.model_for_this_publication.page_height *
              this.zoom}mm;
          `;
        }
      }

      if (this.mode === "stacked")
        return `
          width: ${this.page_width * this.zoom}mm;
          height: ${this.page_height * this.zoom}mm;
        `;
      return;
    },
    setPageContainerProperties() {
      if (this.$root.state.mode === "print_publication") return;

      if (
        this.model_for_this_publication &&
        this.model_for_this_publication.hasOwnProperty("page_width")
      ) {
        if (this.mode === "stacked") {
          return `
            width: ${this.model_for_this_publication.page_width * this.zoom}mm;
            height: ${this.model_for_this_publication.page_height *
              this.zoom}mm;
          `;
        }
      }

      return `
        width: ${this.page_width * this.zoom}mm;
        height: ${this.page_height * this.zoom}mm;
      `;
    },
    setPageProperties() {
      return `
        width: ${this.page_width}mm;
        height: ${this.page_height}mm;
        transform: scale(${this.zoom});
      `;
    },
  },
};
</script>
<style lang="scss" scoped>
.m_pagedPublicationTemplate {
  position: relative;
  margin: 0 auto;
  overflow: visible;
  pointer-events: none;

  &.is--stacked .m_pageContainer {
    position: absolute;

    &:not(:first-child) {
      // z-index: -1;
    }
  }
}

.m_pageContainer {
  position: relative;
  pointer-events: auto;
  margin: 0 auto;
}

.m_page {
  position: relative;
  width: 300px;
  height: 300px;
  transform-origin: top left;

  // font-size: 90%;

  background-color: white;
  margin: 0;
  // box-shadow: 0px 4px 10px #999;
  box-shadow: 0px 0px 10px -5px var(--logo-blue);
}

.m_page--header {
  position: absolute;
  bottom: calc(100% - 1.4cm);
  padding: 0 1cm;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 10pt;
  font-weight: 500;
  text-transform: uppercase;

  &::after {
    content: "";
    position: absolute;
    border-bottom: 1px solid #000;
    left: 1cm;
    right: 1cm;
    bottom: 0;
  }
}
.m_page--media {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // overflow: hidden;
  // font-weight: 400;

  // p,
  // h1,
  // h2,
  // h3,
  // h4 {
  //   margin: 0;
  // }

  // img,
  // video {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   object-fit: cover;
  // }
}
</style>
